import { resolveYAxisMaxMinValues }           from '../sub-services/enrichment.js';
import { extractDataObject }                  from '../sub-services/normalize.js';
import { projectString, projectCompanyFooter,
         projectTransactionFooter }           from '../sub-services/projection.js';
import { parseToNumericOnly }                 from '../../../utilities/sanitize.js';

export const yAxisMinMaxAssembly = (valuesArray) => {
  // --- NEP Technique Orchestrated by Assembler --- //
  /* [NOTE]: zeros are deliberately NOT filtered out here, even though the eval orchestrator DOES filter them
   This is not missing parseToNonZeroOnly symmetry to evals call
   the eval and the assembler intentionally consume DIFFERENT shapes of the same list:
       - over in eval-orchestrators.js the zero filter only exists to ANSWER A QUESTION ("is every value 0?"). Its output list
         is read for its length and thrown away, it is never passed down here.
       - because the zeros themselves are real data and have to stay in the set we run Math.max / Math.min over.
       - EX If we filtered them out here too, an all-negative set containing a single 0 would lose its max:
       [0, -10, -25, -40]  ->  with zeros: max 0 (correct)  |  without zeros: max -10 (wrong)
     and the company sitting at 0 would draw above the top of the axis. netDebtToMarketEquity is where you would hit this -
     one company with zero net debt sitting in a selection of net cash companies.
  */

  // Step 1: Normalize 
  const normalizedArray = parseToNumericOnly(valuesArray)
    
  // Step 2: Enrich - second arg is the factor (i.e. max / min values can only land on increments of 5)
  const { max, min }    = resolveYAxisMaxMinValues(normalizedArray, 5)
  
  // Step 3: Project
  //console.log("[RESULT] Projected y-axis max: ", max)
  //console.log("[RESULT] Projected y-axis min: ", min)
  return {
    max,
    min
  }
}

export const assembleCompanionString = (companionArrayFromDict, orderedSelectedIds, barIndex, cos_txns) => {
  console.log("[SUCCESS - ENTERTING TILE COMPANION ASSEMBLY SERVICE]: Orchestrating NEP Technique for Tile Companion Field(s)")    
  // Step 0: Eval / Guard
  // NOTE: Early Return And Resulting UI Visual in Chart:
    // main service called from face of component - assembleCompanionString- returns nothing for any charted tile with no companion field mapped in the dictionary
    // so early returning nothing here renders exactly as if this tooltip callback were not even registered at all in the chart library config object; i.e. not even a blank row / nothing added to the tooltip height - its like this tooltip callback code didnt even exist, was never hung on the chart library config object!
    // i.e. if tile field (charted field) doesnt have a material companion to include, we dont need one and therefore dont include a key for that tile field hung on the top level of the companion dictionary
    // so dictionary[tileField] results/returns 'undefined' from S0, the eval step
  if (!companionArrayFromDict) {
    console.log("[RESULT] No Companion For Tile")
    return
  }
  
  // Step 1: Normalize / Parse / Extract
  const c_t = extractDataObject(orderedSelectedIds, barIndex, cos_txns)

  // Step 2: Enrich
  // N/A

  // Step 3: Projection
  return projectString(c_t, companionArrayFromDict)



}

export const assembleCompanyFooterCompanion = (orderedIds, barIndex, companies) => {
  console.log("[SUCCESS - ENTERTING COMPANY FOOTER COMPANION ASSEMBLY SERVICE]: Orchestrating NEP Technique for Company Footer Companion")
  // Step 0: Eval / Guard
  // N/A - name is NOT NULL on companies, so there is always a value to project

  // Step 1: Normalize / Parse / Extract
  const co = extractDataObject(orderedIds, barIndex, companies)

  // Step 2: Enrich
  // N/A

  // Step 3: Projection
  return projectCompanyFooter(co)
}

export const assembleTransactionFooterCompanion = (orderedIds, barIndex, transactions) => {
  console.log("[SUCCESS - ENTERTING TRANSACTION FOOTER COMPANION ASSEMBLY SERVICE]: Orchestrating NEP Technique for Transaction Footer Companion")
  // Step 0: Eval / Guard
  // N/A - acquirerName / targetName are always present on transactions, so there is always a value to project

  // Step 1: Normalize / Parse / Extract
  const txn = extractDataObject(orderedIds, barIndex, transactions)

  // Step 2: Enrich
  // N/A

  // Step 3: Projection
  return projectTransactionFooter(txn)
}